"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.textStyle=exports.SubHeading=exports.PaymentWalletContainer=exports.ModuleContainer=exports.BackDropContainer=void 0;const PaymentWalletContainer=exports.PaymentWalletContainer=_styledComponents.default.div`
 padding: 24px 48px;
 @media (max-width: 768px) {
    padding: 24px 12px;
  }
  &.freshPassUI{
    padding: 0px;
  }
`,ModuleContainer=exports.ModuleContainer=_styledComponents.default.div` padding: 0; margin:0;`,SubHeading=exports.SubHeading=_styledComponents.default.h2`font-style: normal;
font-weight: 600 !important;
font-size: 20px !important;
line-height: 24px !important;
/* identical to box height, or 120% */
font-feature-settings: "liga" off, "calt" off;
/* Common/Neutral/N800 BrownRegular */
color:  #2a2928;
margin: 24px 0px 12px 0px`,BackDropContainer=exports.BackDropContainer=_styledComponents.default.div`
.backdrop{
    z-index: 5 !important;
  }`,textStyle=exports.textStyle=`
<style>body{margin:0;font-family:-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}code{font-family:source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace}

</style>`;